import { CSSProperties } from "react";

export const colors = {
  bgColor: "bg-white",
  textColor: "text-white",
  reviewStar: "text-yellow-500",
  bgMovieColor: "bg-[#D9D9D9]",
  movieTextColor: "text-[#636363]",
  textDarkGray: "#636363",
  textBlack: "text-black",
  borderColor: "border-black",
  textGray: "text-gray-500",
  placeholderColor: "placeholder-[#9CA3AF]",
  bgBtnColor: "bg-blue-500",
};

export const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
